import {EmptyState} from "../../../../../empty-state";

export function CustomerServiceOrderListEmptyState() {
  return (
    <div>
      <EmptyState message="You do not have any orders at the moment" />
    </div>
  );
}
